import { render, staticRenderFns } from "./ExternalDataObject.vue?vue&type=template&id=66bcaa36&scoped=true&"
import script from "./ExternalDataObject.vue?vue&type=script&lang=ts&"
export * from "./ExternalDataObject.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalDataObject.vue?vue&type=style&index=0&id=66bcaa36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bcaa36",
  null
  
)

export default component.exports